var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 199 199" } },
    [
      _c("title", [_vm._v("hydro")]),
      _c("g", { attrs: { id: "Hydro" } }, [
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M188,137.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79",
          },
        }),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M188,161.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79",
          },
        }),
        _c("path", {
          staticClass: "cls-1",
          attrs: { d: "M80,25V68H92v34.5L120,56H104l16-31Z" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }